module.exports = __webpack_public_path__ + "img/6_48.9177b69e.png";